var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKosher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51445 1.08569C6.73425 0.714774 7.26496 0.714157 7.4856 1.08455L9.23019 4.01322H12.8831C13.3224 4.01322 13.5946 4.49745 13.3703 4.87991L11.5725 7.94531L13.3677 10.9589C13.5949 11.3403 13.3249 11.827 12.8849 11.829L9.28555 11.8448L7.48745 14.9107C7.26787 15.2851 6.73257 15.2851 6.51298 14.9107L4.72663 11.8648L1.12073 11.8807C0.67917 11.8826 0.405172 11.3951 0.632357 11.0117L2.43864 7.96362L0.630101 4.87991C0.405798 4.49746 0.678022 4.01322 1.11734 4.01322H4.77962L6.51445 1.08569ZM4.17962 5.02572H1.87863L3.02317 6.97723L4.17962 5.02572ZM3.60324 7.9663L5.34581 5.02572H8.66553L10.4071 7.94936L8.71488 10.8348L5.29437 10.8498L3.60324 7.9663ZM3.01872 8.95269L1.88562 10.8648L4.13434 10.8549L3.01872 8.95269ZM5.88666 11.8597L7.00022 13.7584L8.11953 11.8499L5.88666 11.8597ZM9.88091 10.8297L12.117 10.8198L10.9932 8.93316L9.88091 10.8297ZM10.9865 6.96152L12.1218 5.02572H9.83333L10.9865 6.96152ZM8.06238 4.01322H5.94581L7.00133 2.23202L8.06238 4.01322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosher);
export default __webpack_public_path__ + "static/media/kosher.c5f888f8d913508f82873e08f2f3cad1.svg";
export { ForwardRef as ReactComponent };